module.exports = __webpack_public_path__ + "static/media/crown.caa30bcb.svg";